export const searchInputInitialValues = {};

export const searchFilters = [];

export const filters = {
  search: false,
  date: true,
  branches: true,
  dates: true,
};

export const dailyCashClosingConst = {
  MODAL_TITLE: 'Cortes por sucursal',
  MODAL_WIDTH: '95vw',
  TABLE_SCROLL_WIDTH: 1200,
  AUTOMATIC: 'Automático',
  MANUAL: 'Manual',
};
